<template>
  <form @submit.prevent="" novalidate ref="form">
    <div class="container-fluid">
      <div class="snippet general-event-config-snippet">
        <div class="form-group row mb-4">
          <div class="col-lg-6">
            <label>Title*</label>
            <div class="kt-input-icon">
              <input type="text" class="form-control" name="title" maxlength="200" placeholder="Enter Tag Title" :value="item.title"  @input="updateTitle" />
           
              <ValidationMessages :element="v$.item.title" />
            </div>

           
          
          </div>


          <div class="col-lg-6">
            <label>Link</label>
            <!-- <v-select name="category" class="" placeholder="Select Category" label="label" @option:selected="updateCategory" :options="categoryEnum" /> -->
           <input type="text" class="form-control" name="link" maxlength="200" placeholder="Enter Link http://test.com"  :value="item.url" @input="updateLink" />
            
          </div>
        </div>
        
      

        <div class="form-group row mb-4">
          <div class="col-lg-12">
            <label>Description</label>
            <div class="kt-input-icon">
              <textarea rows="3" class="form-control" name="description" placeholder="Enter description"  :value="item.description" @input="updateDescription"></textarea>
            </div>
          </div>
        </div>
      </div>

      
      <div class="form-group row">
        <div class="offset-md-10 col-md-2">
          <div class="setting_wrapper">
            <button type="button" class="btn btn-primary" @click="submitForm">Save</button>
           &nbsp; <button type="button" class="mb-1 mt-1 me-1  btn btn-secondary" @click="cancelClick">Cancel</button>
   
          </div>
        </div>
      </div>

      <FlashMessage group="tag_create" />
    </div>
  </form>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import ObjectID from 'bson-objectid';
import _ from 'lodash';


import { gettingErrorMessage } from "@/services/GetValidationMessage";
import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
import {
  useVuelidate
} from '@vuelidate/core'
import {
  required,
  email,
} from '@vuelidate/validators'


export default {
  name: "TagsCreate",
  components: {       
        ValidationMessages
    },
  data() {
    return {
      moduleId: ObjectID(),
      selectedLanguage: null,
      languages: []
    }
  },

  setup() {
        return {
            v$: useVuelidate()
        }
    },

    validations() {
        return {
            item: {
               
                title: {
                    required,
                }
            }
        };
    },
  computed: {
   // ...mapGetters("EventsSingle", {event: "item"}),
    ...mapGetters("TagsSingle", ["item"])
  },
  

  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.tag_create;
    },
  mounted() {
    // this.fetchEvent(this.$route.params.event_id)
  },
 
  methods: {
    // ...mapActions('BlogsSingle', {
    //   fetchEvent: 'fetchData',

    // }),
    ...mapActions('TagsSingle', [      
      "setName",
      "setLink",
      "setDescription",
      "storeData",
      "resetState"
    ]),

    ...mapActions('TagsIndex', {
      fetchAllSponsors: "fetchData",
      setEditId:"setEditId"
    }),



    
    updateCategory(e) {
      this.setCategory(e.value);
    },
    updateTitle(e) {
      this.setName(e.target.value)
    },
    updateLink(e) {
      this.setLink(e.target.value);
    },
   
    logoErrCb(e) {
      console.log(e)
      this.$flashMessage.show({
              group: 'tag_create',
              type: 'error',
              title: 'Failed',
              text: "Invalid File/Doc format.Please use described valid format"
              
            })
    },
    validate_file(fileInfo) {
      if (_.has(fileInfo, 'key'))
        return fileInfo;
      return null;
    },


   
    updateDescription(e) {
      this.setDescription(e.target.value);
    },

    cancelClick() {
      this.resetState()
    },
    async submitForm(e) {
      e.preventDefault();

      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {

              _.map(this.v$.$errors, (item) => {
                  if (item.$property.indexOf(['title'])) {
                     // this.error_general_tab = true;
                     // this.setErrorGeneralTab = true;
                  } else {
                     // this.setErrorGeneralTab = false;
                  }
              });
            

              return
        }


      this.storeData(this.$route.params.event_id)
          .then(async () => {

            this.fetchAllSponsors(this.$route.params.event_id);
            
            this.$flashMessage.show({
              group : 'tags',
              type  : 'success',
              title : 'Success',
              time  :1200,
              html  : "<ul><li>Tag has been created successfully.</li></ul>",
            });
           
            //  await this.$router.push({name: 'blogs.index', params: {event_id: this.$route.params.event_id}});
              //setTimeout(() =>  this.cancelEdit(), 2000);
                
          })
          .catch((error) => {
                    let html = gettingErrorMessage(error);
                    
                    //if (error.response.data.error) {
                        this.$flashMessage.show({
                            group: 'tag_create',
                            type: 'error',
                            title: 'Failed',
                            text: html || 'Something went wrong',
                            html: html
                        });
                   // }
                })
    },
     cancelEdit() {
    
    }
  }
}
</script>

<style scoped lang="scss">
.form-btn {
  color: #201e1eba;
  padding: 9px;
  margin-left: 5px;
  background: #c0cdd345;
  border-radius: 4px;
  border: 1px solid #80808054;

  &.save-btn {
    background: rgba(210, 206, 201, 0.27);
  }
}
</style>